import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Manages native keyboard behavior via @capacitor/keyboard.
 * Adds/removes 'keyboard-open' class on body to hide bottom tab bar.
 * Only runs on native (iOS/Android) — no-op on web.
 */
export function useNativeKeyboard() {
  useEffect(() => {
    // Skip entirely on web — the Keyboard plugin throws "not implemented on web"
    if (!Capacitor.isNativePlatform()) return;

    let cleanup = () => {};

    const init = async () => {
      let Keyboard;
      try {
        const mod = await import('@capacitor/keyboard');
        Keyboard = mod.Keyboard;
      } catch {
        return;
      }

      try {
        await Keyboard.setAccessoryBarVisible({ isVisible: false });
      } catch {}

      try {
        await Keyboard.setScroll({ isDisabled: false });
      } catch {}

      let showHandle, hideHandle;
      try {
        showHandle = await Keyboard.addListener('keyboardWillShow', () => {
          document.body.classList.add('keyboard-open');
        });
        hideHandle = await Keyboard.addListener('keyboardWillHide', () => {
          document.body.classList.remove('keyboard-open');
        });
      } catch {}

      cleanup = () => {
        showHandle?.remove?.();
        hideHandle?.remove?.();
        document.body.classList.remove('keyboard-open');
      };
    };

    init();

    return () => cleanup();
  }, []);
}
